import { Component, OnInit, TemplateRef, ViewChild, Inject, ViewEncapsulation } from '@angular/core';
import { TransacaoCredito, LinhaExtratoContaCredito, Parcela, RequestRecusarTransacaoType, RequestValidarTransacaoType } from 'src/app/shared/services/acordo-ressarcimento/api/models';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { ParcelaService, TransacaoCreditoService, ExtratoContaCreditoService } from 'src/app/shared/services/acordo-ressarcimento/api/services';
import { LoadingService } from 'src/app/shared/services/components/loading.service';
import { AppComponent } from 'src/app/app.component';
import { Router, ActivatedRoute, RoutesRecognized } from '@angular/router';
import { ConsultarTransacaoCreditoService } from '../conciliacao-validacao.service';
import { PsModalLoadingComponent } from 'porto-seguro-guide';
import * as moment from 'moment';
import { delay, filter, pairwise } from 'rxjs/operators';
import { Location } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-detalhe-validacao',
  templateUrl: './detalhe-validacao.component.html',
  styleUrls: ['./detalhe-validacao.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DetalheValidacaoComponent implements OnInit {
  public selectedSRC = "https://www.bing.com/th?id=ORMS.4a9511273ee0c45ff084f4331d82c3b0&pid=Wdp&w=612&h=304&qlt=90&c=1&rs=1&dpr=1&p=0";
  public embed2: HTMLFormElement;
  public urlDownloadthis = "";
  public jafez = false;
  public fileType = "";
  url: string = "";
  urlSafe: SafeResourceUrl;
  public numeroTransacao: number;
  public transacao: TransacaoCredito = undefined;
  public formTransacao: FormGroup;
  public loadingLista = false;
  public VerModal = false;
  sourceParcela: Parcela[] = [];
  sourceExtrato: LinhaExtratoContaCredito[] = [];
  columnsTemplateParcelas = [];
  columnsTemplateExtratos = [];
  public linhasSelecionadas: LinhaExtratoContaCredito[] = [];
  public linhaSelecionada: LinhaExtratoContaCredito;
  public valorTotalSelecionado: number = 0;
  public Teste: number = 0;
  public valorTotalComprovantes: number = 0;
  public flagReprovarTransacao: boolean = JSON.parse(sessionStorage.getItem('flagReprovarTransacao'));
  public flagAprovarTransacao: boolean = JSON.parse(sessionStorage.getItem('flagAprovarTransacao'));
  public flagVisualizaLinhaCredito: boolean = JSON.parse(sessionStorage.getItem('flagVisualizaLinhaCredito'));
  public flagAjusteManual: boolean = JSON.parse(sessionStorage.getItem('flagAjusteManual'));
  private _isSalvando = false;

  @ViewChild('templateVencimento') private templateVencimento: TemplateRef<Parcela>;
  @ViewChild('templateValor') private templateValor: TemplateRef<Parcela>;
  @ViewChild('templateDevedor') private templateDevedor: TemplateRef<any>;
  @ViewChild('templateDataExtrato') private templateDataExtrato: TemplateRef<LinhaExtratoContaCredito>;
  @ViewChild('templateValorExtrato') private templateValorExtrato: TemplateRef<LinhaExtratoContaCredito>;
  @ViewChild('templateSelecaoExtrato') private templateSelecaoExtrato: TemplateRef<LinhaExtratoContaCredito>;
  @ViewChild('ModalValidadoTransacao') modalValidadoTransacao: PsModalLoadingComponent;
  @ViewChild('ModalRecusadoTransacao') modalRecusadoTransacao: PsModalLoadingComponent;

  constructor(
    private formBuilder: FormBuilder,
    public parcelaService: ParcelaService,
    private loading: LoadingService,
    private transacaoCreditoService: TransacaoCreditoService,
    private consultaTransacaoService: ConsultarTransacaoCreditoService,
    private extratoContaCreditoService: ExtratoContaCreditoService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public sanitizer: DomSanitizer,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    this.columnsTemplateParcelas = [
      { prop: 'acordo.processoRessarcimento.codigoRamoSinistro', label: 'Ramo' },
      { prop: 'acordo.processoRessarcimento.numeroSinistro', label: 'Sinistro' },
      { prop: 'acordo.processoRessarcimento.anoSinistro', label: 'Ano' },
      { prop: 'acordo.codigoAcordo', label: 'Acordo' },
      { prop: 'numeroParcela', label: 'Nº parcela' },
      { label: 'Data de vencimento', template: this.templateVencimento },
      { prop: 'tipoSituacaoParcelaAcordo.nomeTipoSituacaoParcelaAcordo', label: 'Status' },
      { label: 'Valor da parcela', template: this.templateValor },
      { prop: 'acordo.nomeEscritorio', label: 'Escritório' },
      { prop: 'numeroTransacao.numeroTransacao', label: 'Nº Transação' },
      { label: 'Nome do Terceiro', template: this.templateDevedor },
    ];

    this.numeroTransacao = this.route.snapshot.params['numeroTransacao'];
    this.criarFormTransacao();
    this.loading.open();

    this.transacaoCreditoService.obterTransacaoPorNumero(this.numeroTransacao).subscribe(response => {
      this.transacao = response;
      this.carregarTransacao(this.transacao);
      this.loading.close();
    }, error => {
      this.loading.close();
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
    });

  }

  private criarFormTransacao() {
    this.formTransacao = this.formBuilder.group({
      numeroTransacao: null,
      comentarios: null,
      comprovantes: this.formBuilder.array([]),
      arquivos: this.formBuilder.array([]),
      parcelas: this.formBuilder.array([]),
    });
  }

  public log(event) {
    console.log(event);
  }

  public voltar() {
    setTimeout(() => {
      this.consultaTransacaoService.setRealizaPesquisa(true);
      this.location.back();
    }, 500);
  }

  private carregarTransacao(transacao: TransacaoCredito) {
    this.formTransacao.controls['numeroTransacao'].setValue(transacao.numeroTransacao);
    this.formTransacao.controls['comentarios'].setValue(transacao.motivo);

    var codigoContas: number[] = [];
    var dataComprovantes: string[] = [];
    var valorComprovantes: number[] = [];

    //carrega os comprovantes
    const comprovanteControl = <FormArray>this.formTransacao.controls['comprovantes'];
    if (transacao.comprovantes != null) {
      for (let i = 0; i < transacao.comprovantes.length; i++) {
        comprovanteControl.push(this.formBuilder.group({
          dataComprovante: this.getDataFormatada(transacao.comprovantes[i].dataComprovante),
          valorComprovante: transacao.comprovantes[i].valorComprovante,
          codigoContaCredito: transacao.comprovantes[i].contaCredito.nomeConta,
          observacaoComprovante: transacao.comprovantes[i].textoObservacao
        }));

        codigoContas.push(transacao.comprovantes[i].contaCredito.codigoContaCredito);
        dataComprovantes.push(moment(transacao.comprovantes[i].dataComprovante, "YYYY-MM-DD").format("DD/MM/YYYY"));
        valorComprovantes.push(transacao.comprovantes[i].valorComprovante);

        this.valorTotalComprovantes = this.valorTotalComprovantes + transacao.comprovantes[i].valorComprovante;
        this.valorTotalComprovantes = parseFloat(this.valorTotalComprovantes.toFixed(2));
      }
    }

    //carrega os anexos
    const arquivoControl = <FormArray>this.formTransacao.controls['arquivos'];
    if (transacao.arquivos != null) {
      for (let i = 0; i < transacao.arquivos.length; i++) {
        arquivoControl.push(this.formBuilder.group({
          nomeArquivo: transacao.arquivos[i].nome,
          dataInclusao: transacao.arquivos[i].dataInclusao,
          codigoDocumentoGCDE: transacao.arquivos[i].codigoDocumentoGCDE
        }));
      }
    }

    //carrega as parcelas
    if (transacao.parcelaLista.parcelas != null) {
      this.sourceParcela = transacao.parcelaLista.parcelas;
      //console.log(JSON.stringify(this.sourceParcela[0].acordo));
    }

    //carrega as linhas de crédito
    if (transacao.statusTransacao.codigo != 1 && transacao.linhasExtrato != null && transacao.linhasExtrato.length != 0) {
      this.sourceExtrato = transacao.linhasExtrato;

      this.columnsTemplateExtratos = [
        { prop: 'idLancamento', label: 'Nº cod linha'  },
        { prop: 'codigoLinhaExtrato', label: 'Nº linha 1'  },
        { label: 'Data', template: this.templateDataExtrato, filter: false },
        { prop: 'descricaoLancamento', label: 'Lançamento' },
        { prop: 'numeroDocumento', label: 'Nº doc' },
        { label: 'Valor', template: this.templateValorExtrato, filter: false },
        { prop: 'statusLinhaCredito.descricao', label: 'Status', filter: false },
        { prop: 'extratoContaCredito.contaCredito.nomeConta', label: 'Conta', filter: false }
      ];

    } else if (transacao.statusTransacao.codigo == 1 && this.flagVisualizaLinhaCredito == true) {

      console.log("TESTE TRANSACAO");

      //carrega linhas não vinculadas a uma transação com base nos comprovantes da transação
      var parametros: ExtratoContaCreditoService.ObterLinhasExtratoParaValidacaoParams = {
        codigoContaCredito: codigoContas,
        dataComprovante: dataComprovantes,
        valorComprovante: valorComprovantes
      };

      this.extratoContaCreditoService.obterLinhasExtratoParaValidacao(parametros).subscribe(response => {
        this.sourceExtrato = response;
        console.log("this.sourceExtrato" + this.sourceExtrato.toString());
      }, error => {
        this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
      });

      

      this.columnsTemplateExtratos = [
        { prop: 'idLancamento', label: 'Nº cod linha'  },
        { prop: 'codigoLinhaExtrato', label: 'Nº linha 2' },
        { label: 'Data', template: this.templateDataExtrato, filter: false },
        { prop: 'descricaoLancamento', label: 'Lançamento' },
        { prop: 'numeroDocumento', label: 'Nº doc' },
        { label: 'Valor', template: this.templateValorExtrato, filter: false },
        { prop: 'statusLinhaCredito.descricao', label: 'Status', filter: false },
        { prop: 'extratoContaCredito.contaCredito.nomeConta', label: 'Conta', filter: false },
        { label: 'Selecionar', template: this.templateSelecaoExtrato, filter: false }
      ];
    }
  }

  public downloadComprovante(idArquivo, nomeArquivo, idTipoSolicitacao) {

    this.transacaoCreditoService.obterComprovanteTransacao(idArquivo).subscribe(response => {
      if (response) {

        var ext = nomeArquivo.substring(nomeArquivo.lastIndexOf('.') + 1);
        
        if (ext.toLowerCase() == 'pdf') {
          this.fileType = "application/pdf";
        }
        else if (ext.toLowerCase() == 'png') {
          this.fileType = "image/png";
        }
        else if (ext.toLowerCase() == 'jpeg') {
          this.fileType = "image/jpeg";
        } 
        else {
          this.fileType = "application/octet-stream";
          if (idTipoSolicitacao === 1)
          {
            idTipoSolicitacao = 0;
          }
        }
        const blob = new Blob([response], { type: this.fileType });
        const urlDownload = window.URL.createObjectURL(blob);
        //Visualizar Anexo
        if(idTipoSolicitacao === 1)
        {
            this.url = urlDownload
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
            this.VerModal = true;
        }
        //Baixar Anexo
        else if(idTipoSolicitacao === 2)
        {
          const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
          a.href = urlDownload; 
          a.download = nomeArquivo;
          document.body.appendChild(a);
          a.click();
          
          this.appComponent.createAlert('Arquivo baixado com sucesso.', 'success');
         
        }
        //Erro Anexo
        else
        {
          this.VerModal = false;
          this.appComponent.createAlert('Esse tipo de arquivo não pode ser pré-visualizado devido a sua extensão.', 'error');
        }
        setTimeout(() => {
        URL.revokeObjectURL(urlDownload);
      }, 100000);
      }
      
    }, error => {
      
      this.loadingLista = false;
      this.appComponent.createAlert('Não foi possível visualizar ou baixar arquivo.', 'error');
    });
  }

  private getDataFormatada(data: any): string {
    let dataFormatada = '';
    if (data && data !== '') {
      dataFormatada = moment(data, "YYYY-MM-DD").format("DD/MM/YYYY")
    }
    return dataFormatada;
  }

  public recusarTransacao(numeroTransacao: number, ModalRecusar) {
    ModalRecusar.close();
    this.loading.open();

    var parametros: RequestRecusarTransacaoType = {
      numeroTransacao: numeroTransacao,
      textoJustificativaReprovacao: 'recusado'
    }

    this.transacaoCreditoService.recusarTransacao(parametros).subscribe(response => {
      this.loading.close();
      this.modalRecusadoTransacao.open(null);
    }, error => {
      this.loading.close();
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
    });
  }

  public validarTransacao(numeroTransacao: number, ModalValidar) {
    this._isSalvando = true;
    const comprovanteControl = <FormArray>this.formTransacao.controls['comprovantes'];
    //this.valorTotalSelecionado = parseFloat(this.valorTotalSelecionado.toFixed(2));
    //this.valorTotalSelecionado = parseFloat(this.valorTotalSelecionado.toString().split('.')[0] + '.' + this.valorTotalSelecionado.toString().split('.')[1].slice(0, 2));

    
    //verifica se quantidade de registros selecionados é condizente com quantidade de comprovantes
    if (this.linhasSelecionadas.length === comprovanteControl.length && 
      this.valorTotalSelecionado.toFixed(2) === this.valorTotalComprovantes.toFixed(2)) {
      ModalValidar.close(); 
      this.loading.open();

      var parametros: RequestValidarTransacaoType = {
        numeroTransacao: numeroTransacao,
        textoJustificativaValidacao: this.formTransacao.value['comentarios'],
        linhasExtrato: this.linhasSelecionadas
      }

      this.transacaoCreditoService.validarTransacao(parametros).subscribe(response => {
        this.loading.close();
        this.modalValidadoTransacao.open(null);
      }, error => {
        this.loading.close();
        this.loadingLista = false;
        this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
      });  
    } else {
      this.appComponent.createAlert("É necessário selecionar ao menos uma linha por comprovante", 'error');
      this._isSalvando = false;
      return;
    }
    this._isSalvando = false;
  }

  public armazenarLinhaSelecionada(evt, row: LinhaExtratoContaCredito): void {
    this.linhaSelecionada = this.sourceExtrato.find(function (p) { return p.idLancamento == row.idLancamento });
    
console.log("Valor selecionado: "+ row.valorLancamento);

    var target = evt.target;
    if (target.checked) {
      console.log("Valor valorTotalSelecionado ANTES: "+ this.valorTotalSelecionado);
      this.linhasSelecionadas.push(this.linhaSelecionada);
      this.valorTotalSelecionado = this.valorTotalSelecionado + this.linhaSelecionada.valorLancamento;
      //console.log("Valor valorTotalSelecionado DEPOIS: "+ this.valorTotalSelecionado);
     // console.log("Valor linhaSelecionada.valorLancamento DEPOIS: "+ this.linhaSelecionada.valorLancamento);
      row['checked'] = true;
    } else if (!target.checked) {
      console.log("Valor NEGATIVO valorTotalSelecionado ANTES: "+ this.valorTotalSelecionado);
      this.linhasSelecionadas.splice(this.linhasSelecionadas.indexOf(this.linhaSelecionada), 1);
      this.valorTotalSelecionado = this.valorTotalSelecionado - this.linhaSelecionada.valorLancamento;
      console.log("Valor NEGATIVO valorTotalSelecionado DEPOIS: "+ this.valorTotalSelecionado);
      console.log("Valor NEGATIVO linhaSelecionada.valorLancamento DEPOIS: "+ this.linhaSelecionada.valorLancamento);
      row['checked'] = false;
    }
    const comprovanteControl = <FormArray>this.formTransacao.controls['comprovantes'];
    this.valorTotalSelecionado = parseFloat(this.valorTotalSelecionado.toFixed(2));
    console.log("Valor this.linhasSelecionadas.length: "+ this.linhasSelecionadas.length);
    console.log("Valor comprovanteControl.length: "+ comprovanteControl.length);
    console.log("Valor this.valorTotalSelecionado: "+ this.valorTotalSelecionado);
    console.log("Valor this.valorTotalComprovantes: "+ this.valorTotalComprovantes);
    this.Teste = parseFloat(this.valorTotalSelecionado.toString().split('.')[0] + '.' + this.valorTotalSelecionado.toString().split('.')[1].slice(0, 2));
    console.log("Valor this.Teste: "+ this.Teste);
    console.log("Valor total: "+ this.valorTotalSelecionado);
  }

  public atualizarParcela(ModalAtualizaParcela, ModalGravando) {

    ModalAtualizaParcela.close();
    ModalGravando.open();

    this.transacaoCreditoService.atualizarStatusTransacao(this.transacao).subscribe(data => {
      ModalGravando.close();
      this.appComponent.createAlert('Status da Transação atualizada com sucesso!.', 'success');
    }, message => {
      ModalGravando.close();
      if (message.includes('404')) {
        this.appComponent.createAlert('Parcela informada não existe', 'error');
      } else {
        this.appComponent.createAlert('Ocorreu um erro ao atualizar o Status da Transação', 'error');
      }
    });


  }

}
